import { getNumberOrZero } from '@/common/utils'
import { BagScannedPage } from '@/pages/bag-scanned'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/bag-scanned')({
  component: BagScannedPage,
  validateSearch: (search) => {
    return {
      entriesGained: getNumberOrZero(
        search?.entriesGained as string | null | undefined,
      ),
    }
  },
})
